// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"27a4c257","606":"4a97af12","991":"516859ce"}[chunkId] + ".chunk.css";
};